import React, { Component } from "react";
import { Button, message, Table, Modal } from "antd";
import FormSummary from "@components/FormSummary";
import { getAllGames } from "@api/statistics";
import { toCreate, toEdit, toDelete, list } from "@api/recommendGame";
import { getQRcode } from "@api/QRcode";
import bus from "@utils/bus";
import url from "@utils/url";
import { downloadjs } from "@utils/tool";
import { store } from "../store-manager";

// const Option = Select.Option;
const { HOST } = url;
const jsonGames = {};
const confirm = Modal.confirm;

export default class RecommendGame extends Component {
    formRef = React.createRef();
    pFormRef = React.createRef();

    state = {
        pagination: {
            pageSzie: 10,
            current: 1,
            total: 0
        },
        gameId: "",
        operateType: "",
        allSelect: [
            {
                key: "game",
                mode: "multiple",
                placeholder: "请选一级渠道",
                defaultValue: "",
                options: [{ value: "", label: "全部游戏" }],
                title: "选择游戏"
            }
        ],
        popularizeVisible: false,
        visible: false,
        formItems: [
            {
                key: "gameId",
                label: "推广游戏",
                require: true,
                componentName: "select",
                options: [],
                message: "推广游戏必选"
            },
            {
                key: "content",
                label: "推广语",
                require: true,
                componentName: "textarea",
                message: "推广语必填"
            },
            {
                key: "smallIconUrl",
                label: "推广游戏icon (小)",
                require: false,
                componentName: "upload",
                uploadUrl: `${HOST}/cps-gateway/api/v1/partner/img/upload`,
                message: "图片必传"
            },
            {
                key: "normalIconUrl",
                label: "推广游戏icon (中)",
                require: false,
                uploadUrl: `${HOST}/cps-gateway/api/v1/partner/img/upload`,
                componentName: "upload",
                message: "图片必传"
            },
            {
                key: "largeIconUrl",
                label: "推广游戏icon (大)",
                require: false,
                uploadUrl: `${HOST}/cps-gateway/api/v1/partner/img/upload`,
                componentName: "upload",
                message: "图片必传"
            }
        ],
        popularizeFormItems: [
            {
                key: "firstId",
                label: "当前渠道",
                require: true,
                componentName: "select",
                options: [],
                message: "必选",
                onChange: this.handleChannelChange.bind(this)
            },
            {
                key: "channel",
                label: "子渠道",
                require: true,
                componentName: "select",
                options: [],
                message: "必选",
                onChange: this.handleCodesChange.bind(this)
            },
            {
                key: "width",
                label: "宽度",
                require: true,
                componentName: "input",
                message: "请填写二维码宽度"
            },
            {
                key: "minicode",
                label: "小游戏路径 (path)",
                // require: true,
                componentName: "span",
                content: "?channel=x"
                // message: "请填写二维码宽度"
            }
        ],
        popularizeDefaultValue: {},
        formDefaultValue: {},
        tableData: []
    };

    handleCodesChange(data) {
        const { popularizeFormItems } = this.state;

        popularizeFormItems[3].content = `?channel=${data}`;
        this.setState({ popularizeFormItems });
    }

    handleChannelChange(data) {
        const { popularizeFormItems } = this.state;
        const tempCureent = popularizeFormItems[0].options.find(
            item => item.value === data
        );
        const tempSecond = tempCureent.sub || [];

        let tempChannel = [];

        tempSecond.forEach(item => {
            if (
                item.codes &&
                Array.isArray(item.codes) &&
                item.codes.length > 0
            ) {
                tempChannel = [
                    ...tempChannel,
                    { value: item.codes[0], label: item.name }
                ];
            }
        });
        popularizeFormItems[1].options = tempChannel;

        this.setState({ popularizeFormItems });
    }

    getList = async () => {
        const { pagination } = this.state;
        const params = { gameId: this.state.gameId, page: pagination.current, size: 10 };
        const res = await list(params);

        if (res.data.meta.errCode !== 0) { return };

        const tempList =
            (res.data && res.data.data && res.data.data.list) || [];
        pagination.total = res.data.meta.paging.total;

        this.setState({ tableData: tempList, pagination });
    };

    getAllGames = async () => {
        const res = await getAllGames();
        const games = res.data.data || [];
        const tempGameOptions = games.map(item => ({
            value: item.gameId,
            label: item.gameName || item.gameId
        }));
        const { formItems } = this.state;

        tempGameOptions.forEach(item => {
            jsonGames[item.value] = item.label;
        });

        formItems[0].options = tempGameOptions;

        this.setState({ formItems });

        this.setSelectOptions(
            "game",
            [{ value: "", label: "全部游戏" }].concat(tempGameOptions)
        );
    };

    setSelectOptions = (key, options = []) => {
        const tempAllSelect = this.state.allSelect;

        tempAllSelect.forEach(item => {
            if (item.key === key) {
                item.options = options;
            }
        });
        this.setState({ allSelect: tempAllSelect });
    };

    handleCreate = () => {
        this.setState({ visible: true, operateType: "create" });
    };

    handleEdit = data => {
        this.setState({
            visible: true,
            operateType: "edit",
            formDefaultValue: data
        });
    };

    handleOk = async () => {
        let form = this.formRef.current;
        const { operateType } = this.state;

        try {
            const values = await form.validateFields();
            this[operateType](values);
        } catch (err) {
            console.log(err);
        }
    };

    handleParams = data => {
        const { smallIconUrl, normalIconUrl, largeIconUrl } = data;
        const params = { ...data };
        const { operateType, formDefaultValue } = this.state;

        if (smallIconUrl && smallIconUrl.file) {
            params.smallIconUrl = smallIconUrl.file.response.data;
        }
        if (normalIconUrl && normalIconUrl.file) {
            params.normalIconUrl = normalIconUrl.file.response.data;
        }
        if (largeIconUrl && largeIconUrl.file) {
            params.largeIconUrl = largeIconUrl.file.response.data;
        }
        if (operateType === "edit") {
            params.id = formDefaultValue.id;
        }

        return params;
    };

    create = async data => {
        const params = this.handleParams(data);
        const res = await toCreate(params);

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }
        message.success("添加成功");
        this.getList();
        this.setState({ visible: false });
    };

    edit = async data => {
        const params = this.handleParams(data);
        const res = await toEdit(params);

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }
        message.success("编辑成功");
        this.getList();
        this.setState({ visible: false });
    };

    handleSelectChange = (value, key) => {
        this.setState({ gameId: value });
    };

    handleSearch = () => {
        this.getList();
    };

    handleDelete = async data => {
        const { id } = data;
        const _this = this;

        confirm({
            title: `您确认删除嘛?`,
            content: "",
            onOk() {
                toDelete({ id }).then(res => {
                    if (res.data.meta.errCode !== 0) {
                        message.error(res.data.meta.errMsg);
                        return;
                    }
                    message.success("删除成功!");
                    _this.getList();
                });
            }
        });
    };

    handlePopularizeOk = async () => {
        let form = this.pFormRef.current;

        try {
            const values = await form.validateFields();

            const params = {
                gameId: this.state.currentRow.gameId,
                width: values.width,
                channel: values.channel
            };

            const res = await getQRcode(params);
            if (res.status !== 200) {
                message.error("生成二维码失败!");
                return;
            }
            message.success("生成二维码成功!");
            downloadjs(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    handlePopularize = data => {
        this.setState({ popularizeVisible: true, currentRow: data });
    };

    getChannels = async () => {
        await store.hasAllChannel()
        const res = store.remote.channel
        const { popularizeFormItems, popularizeDefaultValue } = this.state;
        const sub =
            (res && res[0] && res[0].sub) || [];
        const firstOptions = sub.map(item => ({
            value: item.id,
            label: item.name,
            sub: item.sub
        }));

        if (firstOptions.length > 0) {
            popularizeFormItems[0].options = firstOptions;
            popularizeDefaultValue.firstId = firstOptions[0].value;

            const tempSecond = firstOptions[0].sub || [];
            let tempChannel = [];

            tempSecond.forEach(item => {
                if (
                    item.codes &&
                    Array.isArray(item.codes) &&
                    item.codes.length > 0
                ) {
                    tempChannel = [
                        ...tempChannel,
                        { value: item.codes[0], label: item.name }
                    ];
                }
            });
            popularizeFormItems[1].options = tempChannel;
        }

        this.setState({ popularizeFormItems, popularizeDefaultValue });
        console.log(sub);
    };

    changePage = page => {
        const { pagination } = this.state;
        pagination.current = page.current;

        this.setState({ pagination }, () => {
            this.getList();
        });
    };

    componentDidMount() {
        this.getList();
        this.getAllGames();

        if (bus.userInfo.roleTp === 5) {
            this.getChannels();
        }

        bus.dispatch("clearBadge");
    }

    render() {
        const columns = [
            {
                title: "游戏ID",
                dataIndex: "gameId",
                align: "center"
            },
            {
                title: "游戏名",
                dataIndex: "gameName",
                align: "center",
                render: (text, record) => {
                    return <span>{jsonGames[record.gameId]}</span>;
                }
            },
            {
                title: "appID",
                dataIndex: "appId",
                align: "center"
            },
            {
                title: "推广语",
                dataIndex: "content",
                align: "center"
            },
            {
                title: "icon(小)",
                dataIndex: "smallIconUrl",
                align: "center",
                render: (text, record) =>
                    text ? (
                        <a
                            href={text}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                style={{ width: 60, height: 60 }}
                                src={text}
                                alt="推广游戏小 icon"
                            />
                        </a>
                    ) : (
                        <span>---</span>
                    )
            },
            {
                title: "icon(中)",
                dataIndex: "normalIconUrl",
                align: "center",
                render: (text, record) =>
                    text ? (
                        <a
                            href={text}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                style={{ width: 70, height: 70 }}
                                src={text}
                                alt="推广游戏 中icon"
                            />
                        </a>
                    ) : (
                        <span>---</span>
                    )
            },
            {
                title: "icon(大)",
                dataIndex: "largeIconUrl",
                align: "center",
                render: (text, record) =>
                    text ? (
                        <a
                            href={text}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                style={{ width: 80, height: 80 }}
                                src={text}
                                alt="推广游戏 大icon"
                            />
                        </a>
                    ) : (
                        <span>---</span>
                    )
            },
            {
                title: "操作",
                dataIndex: "",
                align: "center",
                width: 200,
                render: (text, record) => {
                    return (
                        <div>
                            {bus.userInfo.roleTp === 5 ? (
                                <Button
                                    style={{ marginLeft: 8 }}
                                    type="primary"
                                    size="small"
                                    onClick={() => {
                                        this.handlePopularize(record);
                                    }}
                                >
                                    推广
                                </Button>
                            ) : (
                                <div>
                                    <Button
                                        type="primary"
                                        size="small"
                                        onClick={() => {
                                            this.handleEdit(record);
                                        }}
                                    >
                                        编辑
                                    </Button>
                                    <Button
                                        style={{ marginLeft: 8 }}
                                        type="danger"
                                        size="small"
                                        onClick={() => {
                                            this.handleDelete(record);
                                        }}
                                    >
                                        删除
                                    </Button>
                                </div>
                            )}
                        </div>
                    );
                }
            }
        ];
        const { roleTp } = bus.userInfo;
        const {
            visible,
            formItems,
            formDefaultValue,
            tableData,
            popularizeVisible,
            popularizeFormItems,
            popularizeDefaultValue
        } = this.state;

        return (
            <div>
                <h2 style={{ marginTop: 8 }}>游戏推荐</h2>
                <ul style={{ overflow: "hidden", marginTop: 28 }}>
                    {/* {this.state.allSelect.map(item => {
                        return (
                            <li
                                key={item.key}
                                style={{
                                    float: "left",
                                    width: 280,
                                    marginRight: 20
                                }}
                            >
                                <span style={{ lineHeight: "32px" }}>
                                    {item.title}
                                </span>
                                <Select
                                    optionFilterProp="children"
                                    allowClear={false}
                                    // maxTagCount={1}
                                    // mode={item.mode || ""}
                                    placeholder={item.placeholder}
                                    defaultValue={item.defaultValue}
                                    onChange={value => {
                                        this.handleSelectChange(
                                            value,
                                            item.key
                                        );
                                    }}
                                    style={{ width: "75%", float: "right" }}
                                    showSearch
                                >
                                    {item.options.map(ele => {
                                        return (
                                            <Option
                                                key={ele.value}
                                                value={ele.value}
                                            >
                                                {ele.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </li>
                        );
                    })}
                    <li
                        style={{
                            float: "left",
                            marginRight: 20
                        }}
                    >
                        <Button type="primary" onClick={this.handleSearch}>
                            查询
                        </Button>
                    </li> */}
                    <li
                        style={{
                            float: "right",
                            marginRight: 20
                        }}
                    >
                        {roleTp === 5 ? (
                            ""
                        ) : (
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.handleCreate();
                                }}
                            >
                                添加
                            </Button>
                        )}
                    </li>
                </ul>
                <Table
                    locale={{ emptyText: "暂无数据" }}
                    rowKey={item => item.id}
                    style={{ marginTop: 28 }}
                    columns={columns}
                    // pagination={tableData.length}
                    dataSource={tableData}
                    pagination={this.state.pagination}
                    onChange={(page, pageSize) => {
                        this.changePage(page);
                    }}
                />
                <Modal
                    destroyOnClose={true}
                    title="游戏推荐"
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={() => {
                        this.setState({ visible: false });
                    }}
                    okText="确认"
                    cancelText="取消"
                >
                    <div>
                        <FormSummary
                            labelCols={7}
                            ref={this.formRef}
                            formItems={formItems}
                            formDefaultValue={formDefaultValue}
                        />
                    </div>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title="推广"
                    visible={popularizeVisible}
                    // onOk={this.handlePopularizeOk}
                    onCancel={() => {
                        this.setState({ popularizeVisible: false });
                    }}
                    footer={null}
                    okText="确认"
                    cancelText="取消"
                >
                    <div>
                        <FormSummary
                            labelCols={7}
                            ref={this.pFormRef}
                            formItems={popularizeFormItems}
                            formDefaultValue={popularizeDefaultValue}
                        />
                        <div style={{ textAlign: 'center' }}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.handlePopularizeOk()
                                }}
                            >
                                生成二维码
                            </Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}
